import { render, staticRenderFns } from "./DocumentsTask.vue?vue&type=template&id=94e25ae2&scoped=true&"
import script from "./DocumentsTask.vue?vue&type=script&lang=js&"
export * from "./DocumentsTask.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsTask.vue?vue&type=style&index=0&id=94e25ae2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94e25ae2",
  null
  
)

export default component.exports